package features.schedule.ui.modals

import kotlinx.html.*
import kotlinx.html.dom.append
import kotlinx.html.js.onClickFunction
import org.w3c.dom.HTMLElement
import shared.ui.ModalManager

object EditScheduleModal {
    fun render(root: HTMLElement) {
        root.append {
            div("modal-content fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-dark-800 border border-dark-700 rounded-2xl p-6 w-full max-w-4xl z-[101] hidden shadow-2xl h-[85vh] flex flex-col") {
                id = "edit-schedule-modal"
                
                div("flex justify-between items-center mb-6 flex-shrink-0") {
                    div {
                        h3("text-xl font-bold") { +"Manage Schedule" }
                        p("text-slate-400 text-sm") { 
                            id = "schedule-member-name"
                            +"Member Name" 
                        }
                    }
                    button(classes = "text-slate-400 hover:text-white") {
                        onClickFunction = { ModalManager.close() }
                        +"✕"
                    }
                }
                
                input(type = InputType.hidden) { id = "schedule-member-id" }

                div("flex gap-2 mb-4 border-b border-dark-700 pb-1 flex-shrink-0") {
                    button(classes = "schedule-tab-btn px-4 py-2 text-brand-cyan border-b-2 border-brand-cyan font-medium") {
                        id = "tab-btn-date"
                        onClickFunction = { js("switchScheduleView")("date") }
                        +"By Date"
                    }
                    button(classes = "schedule-tab-btn px-4 py-2 text-slate-400 hover:text-white transition") {
                        id = "tab-btn-shift"
                        onClickFunction = { js("switchScheduleView")("shift") }
                        +"By Shift"
                    }
                }

                div("flex-1 overflow-y-auto pr-2 custom-scrollbar") {
                    // By Date View
                    div("schedule-view") {
                        id = "schedule-view-date"
                        div("grid grid-cols-7 gap-2") {
                            id = "quick-schedule-grid"
                        }
                    }

                    // By Shift View
                    div("schedule-view hidden space-y-4") {
                        id = "schedule-view-shift"
                        div {
                            id = "shift-template-list"
                        }
                    }
                }
            }
        }
    }
}
